<nav class="notifications-nav" [class.hidden]="isHidden" aria-label="Notifications navigation">
  <div class="nav-shell">
    <div class="nav-scroll">
      <ul class="nav-segment" role="tablist">
        <li role="presentation">
          <a
            #navLink
            routerLink="/notifications/time-off"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab">
            <span>Time Off</span>

            <span class="tab-notification-badge" *ngIf="timeOffCount$ | async as count">
              <ng-container *ngIf="count > 0">{{ formatBadgeCount(count) }}</ng-container>
            </span>
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/notifications/supervisor-hours"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab">
            <span>Supervisor Hours</span>

            <span class="tab-notification-badge" *ngIf="supervisorHoursCount$ | async as count">
              <ng-container *ngIf="count > 0">{{ formatBadgeCount(count) }}</ng-container>
            </span>
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/notifications/my-hours"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab">
            <span>My Hours</span>

            <span class="tab-notification-badge" *ngIf="myHoursCount$ | async as count">
              <ng-container *ngIf="count > 0">{{ formatBadgeCount(count) }}</ng-container>
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>